import { render } from "./RMWatchCard.vue?vue&type=template&id=3446916c&scoped=true"
import script from "./RMWatchCard.vue?vue&type=script&lang=js"
export * from "./RMWatchCard.vue?vue&type=script&lang=js"

import "./RMWatchCard.vue?vue&type=style&index=0&id=3446916c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3446916c"]])

export default __exports__